// SPA navigation helper — เปลี่ยนหน้าโดยไม่ reload (ไม่กระพริบ) + loading overlay
// อัปเดต URL ด้วย pushState แล้ว dispatch popstate ให้ <BrowserRouter> ใน App.js สลับ content
// ลิงก์ภายนอก (http) และ modal (#) ปล่อยให้ทำงานตามปกติ
//
// ธีมตั้ง element [data-animatable] ให้ opacity:0 แล้วใช้ JS fade เข้าตอน page-load/scroll
// ซึ่งไม่ทำงานตอน SPA mount -> เนื้อหา (กริดเกม) เลยซ่อน จึงต้องบังคับ reveal หลังสลับหน้า

function revealAnimated() {
  var root = document.getElementById('root');
  if (!root) return;
  var els = root.querySelectorAll('[data-animatable]');
  for (var i = 0; i < els.length; i++) {
    try {
      els[i].style.setProperty('opacity', '1', 'important');
      els[i].style.setProperty('visibility', 'visible', 'important');
    } catch (e) { }
  }
}

// ----- loading overlay -----
function showLoader() {
  var l = document.getElementById('__spaLoader');
  if (!l) {
    l = document.createElement('div');
    l.id = '__spaLoader';
    l.innerHTML = '<i class="fas fa-spinner fa-spin __spaSpin"></i>';
    document.body.appendChild(l);
  }
  // วาง loader เฉพาะกล่องเนื้อหา (#root) ที่กำลังโหลด ไม่คลุม sidebar/navbar ทั้งหน้า
  var root = document.getElementById('root');
  if (root) {
    var r = root.getBoundingClientRect();
    var top = Math.max(r.top, 0);
    l.style.top = top + 'px';
    l.style.left = Math.max(r.left, 0) + 'px';
    l.style.width = r.width + 'px';
    l.style.height = (window.innerHeight - top) + 'px';
  } else {
    l.style.top = '0'; l.style.left = '0'; l.style.width = '100%'; l.style.height = '100%';
  }
  l.style.display = 'flex';
}
function hideLoader() {
  var l = document.getElementById('__spaLoader');
  if (l) l.style.display = 'none';
}

// reveal ทันที + เฝ้าดู content ที่เพิ่ง mount/ข้อมูลที่โหลดช้า แล้วซ่อน loader เมื่อพร้อม
function scheduleReveal() {
  var root = document.getElementById('root');
  showLoader();
  revealAnimated();
  var start = Date.now();
  var MIN = 250, MAX = 2500;
  if (!root || typeof MutationObserver === 'undefined') {
    setTimeout(function () { revealAnimated(); hideLoader(); }, 900);
    return;
  }
  try {
    var obs = new MutationObserver(function () {
      revealAnimated();
      // ซ่อน loader เมื่อมีเนื้อหา (รูป) โหลดมาพอสมควร และผ่านเวลาขั้นต่ำแล้ว
      if (Date.now() - start > MIN && root.querySelectorAll('img').length > 20) {
        hideLoader();
      }
    });
    obs.observe(root, { childList: true, subtree: true });
    setTimeout(function () { revealAnimated(); obs.disconnect(); hideLoader(); }, MAX);
  } catch (e) {
    setTimeout(function () { revealAnimated(); hideLoader(); }, 700);
  }
}

// ติดตั้ง listener ครั้งเดียว -> ครอบคลุมทั้ง spaNav และ checkurl ของ sidebar (ทั้งคู่ dispatch popstate)
if (typeof window !== 'undefined' && !window.__spaRevealInstalled) {
  window.__spaRevealInstalled = true;
  window.addEventListener('popstate', scheduleReveal);
}

export function spaNav(e, url) {
  if (!url || typeof url !== 'string') return;
  if (url.startsWith('http') || url.startsWith('#')) return; // external / modal: default behavior
  if (e) e.preventDefault();
  try {
    if (url !== window.location.pathname) {
      window.history.pushState({}, '', url);
    }
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
    scheduleReveal();
  } catch (err) {
    window.location.href = url;
  }
}

export { revealAnimated, scheduleReveal, showLoader, hideLoader };
export default spaNav;
